import { declareFont, defineFont, fontWeights, Font } from '../utils/FontUtils'

type Declarations = {
  BbComputerRegular: Font
  BbComputerCond: Font
  BbComputerCondBold: Font
}

type Fonts = { [key in keyof Declarations]: string }

export const declaration: Declarations = {
  BbComputerRegular: {
    srcPath: 'BbComputer/BB-Regular',
    formats: ['ttf'],
    fontFamily: 'BbComputer-Regular',
    fontWeight: fontWeights.regular,
    fallback: 'sans-serif',
  },
  BbComputerCond: {
    srcPath: 'BbComputer/BB-Cond',
    formats: ['ttf'],
    fontFamily: 'BbComputer-Cond',
    fontWeight: fontWeights.regular,
    fallback: 'sans-serif',
  },
  BbComputerCondBold: {
    srcPath: 'BbComputer/BB-CondBold',
    formats: ['ttf'],
    fontFamily: 'BbComputer-CondBold',
    fontWeight: fontWeights.regular,
    fallback: 'sans-serif',
  },
}

export const fontsFaces = (): string => Object.values(declaration).map(declareFont).join(' ')

const fonts: Fonts = {
  BbComputerRegular: defineFont(declaration.BbComputerRegular),
  BbComputerCond: defineFont(declaration.BbComputerCond),
  BbComputerCondBold: defineFont(declaration.BbComputerCondBold),
}

export default fonts
